import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { doImageShake, doTransition, doWaitImageByTime, isAnnGF } from "../helpers/helpers";
import { emily } from "../characters/Emily";
import { V9EmilyNightDayTwoAfter } from "./V9";
import { empty } from "../characters/empty";
import { times } from "lodash";
import { vanessa } from "../characters/Vanessa";
import { ann } from "../characters/Ann";

const v9 = images.v9;
export const V9EmilyNightDayTwo = async (): Promise<any> => {

    mc.think(`It's pretty late, but Emily insisted that I tell her about my date with Alex.`);
    doTransition(v9.V9EmilyNightSleepDay2_3);
    mc.talk(`Emily...`, { method: "Whispering" });
    mc.talk(`...`);
    mc.talk(`Emily...`, { method: "Whispering" });
    emily.talk(`Mmm...`);
    mc.talk(`You told me to wake you up when--`);
    emily.talk(`Let's talk about that in the morning...`);
    emily.talk(`Can we just cuddle for now?`);
    mc.talk(`Of course.`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_4);
    mc.think(`Holy shit!`);
    mc.think(`She invited me to cuddle while naked.`);
    mc.think(`It would be rude of me to enter with clothes on...`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_0);
    // TODO: if kissed Alex maybe say my boner from Alex just wore off and now this. YES

    mc.think(`Fuck... I'm getting a boner!`);
    ImageClass.setImage(v9.V9EmilyNightSleepDay2_11);
    empty.think(`Bzzz...`);
    mc.think(`What the...`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_10);
    mc.think(`Fucking mosquito. It stung me.`);
    mc.think(`I think it's gone.`);
    doWaitImageByTime(images.v9.V9EmilyNightSleepDay2_0);
    mc.think(`Let's get back to the important stuff...`);
    mc.think(`Ouch!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_12, { wait: true });
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_13);
    mc.think(`What the fuck?`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_14);
    mc.think(`You again?`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_16);
    vanessa.talk(`What's wrong? I got the impression we had a good thing going on here.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_15);
    mc.think(`How is you suddenly appearing here out of nowhere a good thing?`);
    mc.think(`Can't you see I'm in the middle of something?`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_16);
    vanessa.talk(`Exactly!`);
    vanessa.talk(`I'm here to make sure your boner won't go to waste!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_13);
    if (Question.globalAnswers.V8EmilyMovieNightTouchHerBreasts === false) {
        vanessa.talk(`You fucked up last time; I won't allow it this time.`);
    } else {
        vanessa.talk(`Last time it worked wonderfully, didn't it?`);
    }
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_15);
    mc.think(`I don't need any help. I know exactly what I'm doing.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_16);
    vanessa.talk(`Yeah...`);
    vanessa.talk(`By the way, it's time to let go of my pitchfork.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_17);
    mc.think(`Sure.`, { wait: 1 });
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_18, { wait: 1 });
    vanessa.talk(`Ahhhhhh!`, { wait: 1 });
    doImageShake(v9.V9EmilyNightSleepDay2_19, { wait: 1.7 });
    doImageShake(v9.V9EmilyNightSleepDay2_20);
    vanessa.talk(`Ouch!`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_21);
    vanessa.talk(`Anyway...`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_22);
    vanessa.talk(`I think it's time to fuck her...`);
    vanessa.talk(`You are naked... She is naked... You have a boner. Everything fits!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_23);
    mc.think(`Besides the fact that she is sleeping...`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_22);
    vanessa.talk(`NAKED!`);
    vanessa.talk(`Come on! You are so close, your dick is almost there!`);
    ann.talk(`Wait!`, { method: "Weird Voice" });
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_37);
    mc.think(`I was wondering when Ann would show up.`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_24);
    vanessa.talk(`I agree with the smoking hot demon.`);
    vanessa.talk(`You should fuck her right now.`);
    mc.think(`...`);
    mc.think(`You are not Ann...`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_25);
    vanessa.talk(`Really? What gave it away?`);
    ann.talk(`HEY!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_29);
    ann.talk(`You stole my clothes!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_28);
    if (isAnnGF()) {
        vanessa.talk(`Another one with keen observation skills.\nNo wonder you are a couple.`);

    } else {
        vanessa.talk(`Another one with keen observation skills.\nI have no idea why you aren't a couple.`);

    }
    vanessa.talk(`I told you last time.\nI won't allow you to have the better outfit.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_27);
    ann.talk(`You know, I can't control what I'm wearing!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_28);
    vanessa.talk(`So, it's not really my fault, is it?`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_26);
    ann.talk(`${mc.name}! Do something!`);
    mc.think(`Me? I have no idea what's going on.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_29);
    ann.talk(`Wait... How did you steal my clothes anyway! We never take them off.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_28);
    vanessa.talk(`That's one of the perks of being a demon...`);
    vanessa.talk(`I may not have wings or shoes...`);
    vanessa.talk(`But I can do all sorts of cool stuff.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_30);
    vanessa.talk(`Here, watch this:`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_31);
    ann.talk(`What are you doing...?`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_32, null, 2);
    ann.talk(`Oh my!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_33);
    ann.talk(`My breasts!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_34);
    ann.talk(`Hey!!!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_38);
    vanessa.talk(`You're welcome.`);
    vanessa.talk(`Consider it a favor.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_35);
    ann.talk(`I don't want this! Put them back to what they were!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_38);
    vanessa.talk(`It's so rude to return gifts. You of all people should know that.`);
    vanessa.talk(`You know... Being an angel and all.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_34);
    ann.talk(`I don't have to stand here and take it!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_39);
    ann.talk(`I'm out of here!`);

    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_40);
    vanessa.talk(`Can you believe it?`);
    vanessa.talk(`I did her a favor, and that's the thanks I get.`);

    vanessa.talk(`If only I knew that's what it takes to get rid of her.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_41);
    mc.think(`I think it's a good time for you to disappear as well.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_40);
    vanessa.talk(`Suit yourself.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_42, { wait: .5 });
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_43, { wait: .3 });
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_44.partials.V9EmilyNightSleepDay2_44_2, { wait: false });
    empty.think("*Poof!*");

    doWaitImageByTime(images.v9.V9EmilyNightSleepDay2_11);
    mc.think(`I can't believe I still have a boner after all that.`);
    mc.think(`I feel like I'm going to explode.`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_6);
    mc.think(`How am I supposed to sleep like this?`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_7);
    mc.think(`She is basically squeezing my dick with her thighs!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_6);
    mc.think(`Maybe if I just...`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_5);
    mc.think(`Damn, that feels good!`);
    doWaitImageByTime(images.v9.V9EmilyNightSleepDay2_6);
    mc.think(`Is she awake?`);
    doWaitImageByTime(v9.V9EmilyNightSleepDay2_5);
    mc.think(`Does she feel it when I do this?`);
    doWaitImageByTime(images.v9.V9EmilyNightSleepDay2_6);
    mc.think(`Fuck!!! I'm actually cumming!`);
    doWaitImageByTime(images.v9.V9EmilyNightSleepDay2_5);
    doImageShake(images.v9.V9EmilyNightSleepDay2_45);
    mc.think(`Shit!`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_8);
    mc.think(`I wonder if she feels it...`);
    ImageClass.setImage(images.v9.V9EmilyNightSleepDay2_9);
    mc.think(`Better keep calm and try to get some sleep...`);

    return jump(V9EmilyNightDayTwoAfter, "V9EmilyNightDayTwoAfter");
};
